<template>
  <div>
    <b-link v-for = "item in menus"
                     :to="{name: 'geo-'+item.name}"
                     :key="item.name"
                      :class="{'un-activite': isUnActivite(item)}">
      {{item.desc}}
    </b-link>
  </div>
</template>

<script>
  export default {
    components: {
    },
    props: {
    },
    data () {
      return {
        menus: [
          {
            name: 'stateMap',
            desc: 'Map'
          },
          {
            name: 'stateList',
            desc: 'List'
          }
        ]
      }
    },
    methods: {
      isUnActivite (item) {
        return 'geo-' + item.name !== this.$route.name
      }
    }
  }
</script>

<style scoped lang="scss">
.un-activite {
  color: $color-text-grey;
}
</style>



// WEBPACK FOOTER //
// src/components/geo/MGeoStateMenu.vue